import {
  TableField,
  currencyFormatter4Digits,
} from "../../table-field";

export const fieldsFracassados: TableField[] = [
  {
    key: "DeItemMatServ",
    label: "Descrição do Item",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
  },
  {
    key: "QtItemMatServ",
    label: "Quantidade",
    tdClass: ["align-middle", "naoQuebrar", "text-center"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
    formatter: (value, key, item) => `${value} ${item.DeUnidadeMedida}`,
  },
  {
    key: "VlUnitarioEstimado",
    label: "Valor Unitário Estimado",
    tdClass: ["align-middle", "naoQuebrar", "text-center"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
    formatter: currencyFormatter4Digits,
  },
  {
    key: "VlTotalEstimado",
    label: "Valor Total",
    tdClass: ["align-middle", "naoQuebrar", "text-center"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
    formatter: currencyFormatter4Digits,
  },
];
